/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Refresh Icon component.
 */
export const SideNavNotificationsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d='M19.6271 12.3516V8.33955C19.6495 6.48019 18.9023 4.68365 17.5394 3.31987C16.1765 1.95608 14.3017 1.12886 12.301 1.00855C11.2601 0.96125 10.2197 1.11062 9.24303 1.44756C8.26631 1.78451 7.37359 2.302 6.61908 2.96866C5.86457 3.63531 5.26399 4.43723 4.8538 5.3257C4.4436 6.21417 4.23235 7.17067 4.23286 8.13716V12.3516C4.24046 13.2395 3.96323 14.1095 3.43642 14.8509C3.15178 15.2407 2.99975 15.7007 3 16.1714V16.1714C3 16.4861 3.06693 16.7977 3.19694 17.0884C3.32695 17.379 3.51749 17.6431 3.75767 17.8654C3.99785 18.0876 4.28294 18.2638 4.59663 18.3838C4.91031 18.5037 5.24642 18.5651 5.58573 18.5645H18.2743C18.6136 18.5651 18.9497 18.5037 19.2634 18.3838C19.5771 18.2638 19.8622 18.0876 20.1023 17.8654C20.3425 17.6431 20.533 17.379 20.6631 17.0884C20.7931 16.7977 20.86 16.4861 20.86 16.1714V16.1714C20.8603 15.7007 20.7082 15.2407 20.4236 14.8509C19.8968 14.1095 19.6195 13.2395 19.6271 12.3516V12.3516Z'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit={10} />
      <path d='M15.06 20.2695C15.06 20.9284 14.7408 21.5602 14.1725 22.0261C13.6043 22.4919 12.8336 22.7537 12.03 22.7537C11.2264 22.7537 10.4557 22.4919 9.88745 22.0261C9.31922 21.5602 9 20.9284 9 20.2695'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit={10} />
    </svg>
  );
};
